/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Workbook } from "./Workbook";
export const WorkbookResponse = core.serialization.object({
    data: Workbook,
});
